import React from 'react';
import PropTypes from 'prop-types';
import Box from 'common/components/Box';
import Text from 'common/components/Text';
import Heading from 'common/components/Heading';
import Image from 'common/components/Image';
import Container from 'common/components/UI/Container';
import Link from 'gatsby-link';

import { ActiveStatus } from './contact.style';
import Author from 'common/assets/image/portfolio/tinyimage.jpg';

const ContactSection = ({
  sectionWrapper,
  secTitleWrapper,
  secTitle,
  secDescription,
  replyWrapper,
  replyTime,
  buttonStyle,
  buttonWrapper,
}) => {
  return (
    <Box {...sectionWrapper} as="section">
      <Container noGutter mobileGutter width="1200px">
        <Box {...secTitleWrapper}>
          <Heading {...secTitle} className="braniac_h" content="OK BRANIAC, so?" />
          <Text
            {...secDescription} className="braniac_d"
            content="Bare with me. I'm trying to prove a point. Ok, here is one of those ✌️motivational✌️ sentences (It's mine, it's not stolen, I'm smart sometimes) - Good UX-ers love design, great UX-ers simply don't care about how it looks, if it works, you got yourself a bullseye. Measure the Usability baby, not the aesthetics. Like a nice book cover with shitty content. So, stop clicking that button above, Click the tiny image of me below."
          />
        </Box>
        <Box {...replyWrapper}>
          <ActiveStatus>
           <Link to="/nothome"><Image src={Author} alt="Tini Tiny Image" /></Link>
          </ActiveStatus>
          <Heading
            as="h4"
            content="← The tiny image"
            {...replyTime}
          />
        </Box>
        {/* <Box {...buttonWrapper}>
          <ButtonWrapper>
            <Button
              title="hello@ilija.guru"
              className="portfolio_button"
              {...buttonStyle}
            />
          </ButtonWrapper>
        </Box> */}
      </Container>
    </Box>
  );
};

ContactSection.propTypes = {
  sectionWrapper: PropTypes.object,
  secTitleWrapper: PropTypes.object,
  secTitle: PropTypes.object,
  secDescription: PropTypes.object,
  replyWrapper: PropTypes.object,
  replyTime: PropTypes.object,
  buttonStyle: PropTypes.object,
  buttonWrapper: PropTypes.object,
};

ContactSection.defaultProps = {
  sectionWrapper: {
    pt: ['70px', '80px', '100px', '100px', '100px'],
    pb: ['70px', '80px', '100px', '100px', '100px'],
    bg: '#f9f9f9',
  },
  secTitleWrapper: {
    mb: '30px',
  },
  secTitle: {
    fontSize: ['22px', '26px', '26px', '30px', '30px'],
    fontWeight: '600',
    color: '#111',
    lineHeight: '1.34',
    mb: ['15px', '18px', '18px', '20px', '20px'],
    textAlign: 'center',
  },
  secDescription: {
    fontSize: ['15px', '16px'],
    fontWeight: '400',
    color: '#111',
    lineHeight: '1.5',
    textAlign: 'center',
    width: '100%',
    maxWidth: '100%',
    ml: 'auto',
    mr: 'auto',
    mb: '0',
  },
  replyWrapper: {
    flexBox: true,
    alignItems: 'center',
    justifyContent: 'center',
  },
  replyTime: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#111',
    mb: 0,
  },
  buttonStyle: {
    type: 'button',
    fontSize: '16px',
    fontWeight: '500',
    color: '#fff',
    pl: '23px',
    pr: '23px',
  },
  buttonWrapper: {
    flexBox: true,
    justifyContent: 'center',
    mt: '50px',
  },
};

export default ContactSection;
